// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VLDak","rootNoMargin":"styles_rootNoMargin__1AmSA"};